function footer() {
  const windowWidth = window.innerWidth;
  const breakPoint = 768;
  const $footerAccordionTrigger = document.querySelectorAll('.footer__block--area-bottom .footer__navigation-inner');

  if (windowWidth <= breakPoint) {
    $footerAccordionTrigger.forEach((accordionTrigger) => {
      accordionTrigger.querySelector('.footer__navigation-kicker').addEventListener('click', () => {
        if (accordionTrigger.classList.contains('open')) {
          accordionTrigger.classList.remove('open');
        } else {
          accordionTrigger.classList.add('open');
        }
      });
    });
  }
}

footer();
